import React from "react";
import MainApp from "./prototype"; 

function App() {
  return (
    <div className="App">
      <MainApp />
    </div>
  );
}

export default App;
